import { observer } from 'mobx-react-lite';
import { useState, type ComponentProps } from 'react';

import { apiImageUrl } from '@shared/lib/media/image-url';

import { useShopCatalog } from '../model/shop-catalog';

type Props = Omit<ComponentProps<'img'>, 'src'> & { kind: string; fallback: string; imageUrl?: string };

export const CatalogImage = observer(({ kind, fallback, imageUrl, alt = '', ...props }: Props) => {
  const catalog = useShopCatalog();
  const image = imageUrl ?? catalog.image(kind);
  const source = (image ? apiImageUrl(image) : null) ?? fallback;
  const [failedSource, setFailedSource] = useState<string | null>(null);
  return (
    <img
      {...props}
      src={failedSource === source ? fallback : source}
      alt={alt}
      onError={() => setFailedSource(source)}
    />
  );
});
